import angular from 'angular';

angular
  .module('cloudX')
  .controller('YesNoDialogCtrl', [
    '$scope',
    'appMessages',
    'close',
    'title',
    'message',
    'params',
    yesNoDialogCtrl,
  ]);

function yesNoDialogCtrl($scope, appMessages, close, title, message, params) {
  $scope.title = appMessages(title, params);
  $scope.message = appMessages(message, params);
  $scope.close = function(result) {
    close(result, 500);
  };
}
